import type { Brand } from './types'

/** Convierte una Brand en el mapa de CSS variables `--brand-*` (puro, sin DOM). */
export function brandCssVars(brand: Brand): Record<string, string> {
  const c = brand.colors
  return {
    '--brand-dark': c.dark,
    '--brand-bg': c.bg,
    '--brand-primary': c.primary,
    '--brand-border': c.border,
    '--brand-muted': c.muted,
    '--brand-aq': c.aq, '--brand-aq2': c.aq2,
    '--brand-bl': c.bl, '--brand-bl2': c.bl2,
    '--brand-sg': c.sg, '--brand-sg2': c.sg2,
    '--brand-sd': c.sd, '--brand-sd2': c.sd2,
    '--brand-font': brand.fontFamily,
  }
}
